module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ag-3f18bb58815f1eb37b603c82f58bb62e.svg";